import React, { Component } from 'react';
import { EmployeeDashboardMobileStyles } from '../../../styles/mobileStyles';
import { withStyles, Button, Drawer, Grid } from '@material-ui/core';
import clsx from 'clsx';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight, faTimes } from '@fortawesome/pro-light-svg-icons';
import { formatAs, DateFnsFormats } from '../../../../common-client2/src/services/ukgDateTime';
import { MomentFormats } from '../../../utils';
import { removeBrowserTimezoneConversion } from './../../../../common-client2/src/services/ukgDateTime/ukgDateTime';

const anchor = "bottom";
class DateSelectionBar extends Component {

    static rangeTypes = {
        day: "Day",
        month: "Month"
    }

    constructor(props) {
        super(props);

        this.state = {
            bottom: false
        }
    }

    selectMonth(month) {
        const handleSelectMonth = this.props.handleSelectMonth;
        handleSelectMonth(month);

        this.setState({
            bottom: false
        });
    }

    renderMonthList(classes) {
        let now = moment().add(-3, "months");
        let monthList = [];
        let first = true;
        for (let i = 24 - now.format(MomentFormats.Month); i >= 0; i--) {
            if (now.format(MomentFormats.Month) === "1" || first) {
                monthList.push(<div className={classes.monthListYear}>{now.format(MomentFormats.Year)}</div>);
                first = false;
            }
            let dateStr = now.format(MomentFormats.YMD);
            monthList.push(<div className={classes.monthListMonth} onClick={() => this.selectMonth(dateStr)} >{now.format(MomentFormats.MMMM)}</div>);

            now = now.add(1, 'M');
        }

        return monthList;
    }

    toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        this.setState({
            ...this.state,
            [anchor]: open
        });
    };

    formatDate(date, rangeType) {
        switch (rangeType) {
            case DateSelectionBar.rangeTypes.month:
                return formatAs(date, DateFnsFormats.VERBOSE_MONTH_YEAR);
            case DateSelectionBar.rangeTypes.day:
                return formatAs(date, DateFnsFormats.VERBOSE_LONG_DATE_FORMAT);
            default:
                return date;
        }
    }

    render() {
        const { classes, rangeType, currentDay, dateIcon, handlePrevious, handleNext, handleDayClick } = this.props;
        let dateClickFunction;

        switch (rangeType) {
            case DateSelectionBar.rangeTypes.month:
                dateClickFunction = this.toggleDrawer(anchor, true);
                break;
            case DateSelectionBar.rangeTypes.day:
                dateClickFunction = handleDayClick;
                break;
            default:
                dateClickFunction = () => { };
                break;
        }

        return (
            <React.Fragment>
                <div className={classes.monthSelectorBar}>
                    <Grid container>
                        <Grid item xs={2} className={classes.lightBorderRight}>
                            <Button onClick={handlePrevious} className={clsx(classes.button, classes.arrowButton)}><FontAwesomeIcon icon={faAngleLeft} size="2x" /></Button>
                        </Grid>
                        <Grid container xs={8}>
                            <Button className={classes.horizontalCentered} onClick={dateClickFunction}>
                                {this.formatDate(removeBrowserTimezoneConversion(currentDay), rangeType)}
                                {dateIcon ? <FontAwesomeIcon icon={dateIcon} style={{ marginLeft: '5px' }} /> : null}
                            </Button>
                        </Grid>
                        <Grid item xs={2}>
                            <Button onClick={handleNext} className={clsx(classes.button, classes.arrowButton)}><FontAwesomeIcon icon={faAngleRight} size="2x" /></Button>
                        </Grid>
                    </Grid>
                </div>
                {
                    rangeType === DateSelectionBar.rangeTypes.month ?
                        <Drawer anchor={anchor} open={this.state[anchor]} onClose={this.toggleDrawer(anchor, false)} classes={{ paper: classes.drawerFullHeight }}>
                            <div className={classes.monthListContent}>
                                <FontAwesomeIcon className={classes.closeButton} onClick={this.toggleDrawer(anchor, false)} icon={faTimes} size="2x" />
                                {this.renderMonthList(classes)}
                            </div>
                        </Drawer>
                        : null
                }
            </React.Fragment>
        );
    }
}

export default withStyles(EmployeeDashboardMobileStyles)(DateSelectionBar);
